// ** Third Party Components
import styled from "styled-components";

// #####################################################

export const StyledCheckboxContent = styled("span")`
	cursor: pointer;
	margin-left: 0.5rem;
`;

// #####################################################
